import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { DatePicker } from "rsuite";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { errorTypes } from "../../../utility/InputValidation";
import { toast } from "react-toastify";
import moment from "moment";

const UpdateBillingDetailsModal = ({
    show,
    onClose,
    invoiceDetail,
    GetInvoiceDetail,
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const {
        register,
        handleSubmit,
        setValue,
        getValues,
        trigger,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            billToName: "",
            billToAddress: "",
            billToGst: "",
            billToPan: "",
            shipToName: "",
            shipToAddress: "",
            shipToGst: "",
            shipToPan: "",
        },
    });

    useEffect(() => {
        if (invoiceDetail) {
            setValue("billToName", invoiceDetail?.billedToName || "");
            setValue("billToAddress", invoiceDetail?.billedToAddress || "");
            setValue("billToGst", invoiceDetail?.billedToGst || "");
            setValue("billToPan", invoiceDetail?.billedToPan || "");
            setValue("shipToName", invoiceDetail?.shippedToName || "");
            setValue("shipToAddress", invoiceDetail?.shippedToAddress || "");
            setValue("shipToGst", invoiceDetail?.shippedToGst || "");
            setValue("shipToPan", invoiceDetail?.shippedToPan || "");

            if (invoiceDetail?.otherReference) {
                const dates = invoiceDetail.otherReference.split(" - ");
                if (dates.length === 2) {
                    setValue("startDate", moment(dates[0], "DD-MMM-YYYY").isValid() ? moment(dates[0], "DD-MMM-YYYY").format("YYYY-MM-DD") : "");
                    setValue("endDate", moment(dates[1], "DD-MMM-YYYY").isValid() ? moment(dates[1], "DD-MMM-YYYY").format("YYYY-MM-DD") : "");
                }
            }
        }
    }, [invoiceDetail, setValue]);

    const onSubmit = async (data) => {

        const postData = {
            billedToName: data?.billToName,
            billedToAddress: data?.billToAddress,
            billedToGst: data?.billToGst,
            billedToPan: data?.billToPan,
            shippedToName: data?.shipToName,
            shippedToAddress: data?.shipToAddress,
            shippedToGst: data?.shipToGst,
            shippedToPan: data?.shipToPan,
            otherReference: (data?.startDate && data?.endDate) ? moment(data?.startDate).format("DD-MMM-YYYY") + " - " + moment(data?.endDate).format("DD-MMM-YYYY") : "",
        }


        const formData = new FormData();
        Object.keys(postData).forEach((key) => {
            const value = postData[key];
            if (value !== null && value !== undefined) {
                formData.append(key, value);
            }
        });
        setIsLoading(true);
        try {
            const endPoint = apiUrl.update_invoice + `?invoiceId=${invoiceDetail?.id}`;

            const res = await callApi(endPoint, {
                method: "POST",
                form_data: formData,
            });

            setIsLoading(false);
            if (res?.status === true) {
                toast.success(res?.message);
                onClose();
                GetInvoiceDetail();
            } else {
                toast.error(res?.message);
            }
        } catch (error) {
            setIsLoading(false);
            toast.error("Something went wrong while saving invoice");
        }
    };

    return (
        <Modal
            className="modal-dialog modal-dialog-scrollable modal-xl modal-dialog-centered"
            isOpen={show}
            toggle={onClose}
        >
            <div className="modal-content">
                <div className="modal-header border-0">
                    <h1 className="modal-title fs-3 rajdhani-semibold">Update Billing Details</h1>
                </div>

                <div className="modal-body p-1">
                    <div className="d-flex justify-content-center align-items-start mt-3">
                        <div
                            className="card border-0 w-100"
                            style={{ backgroundColor: "#f9fafd" }}
                        >

                            <form onSubmit={handleSubmit(onSubmit)} className="p-4">
                                <div className="row g-4">
                                    {/* Bill To Section */}
                                    <div className="col-md-6">
                                        <div className="d-flex align-items-start border rounded-3 bg-white shadow-sm p-3 position-relative h-100">
                                            <div className="w-100">
                                                <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-4">
                                                    <h4 className="mb-0 rajdhani-semibold text-dark">Bill To</h4>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label fw-semibold small text-muted">Name <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className={`form-control`}
                                                        placeholder="Enter Bill To Name"
                                                        {...register("billToName", { required: "Name is required" })}
                                                    />
                                                    <ErrorMessage message={errors?.billToName?.message} />
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label fw-semibold small text-muted">Address <span className="text-danger">*</span></label>
                                                    <textarea
                                                        className={`form-control`}
                                                        placeholder="Enter Bill To Address"
                                                        rows="3"
                                                        {...register("billToAddress", { required: "Address is required" })}
                                                    ></textarea>
                                                    <ErrorMessage message={errors?.billToAddress?.message} />
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label fw-semibold small text-muted">GST <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className={`form-control`}
                                                        placeholder="Enter Bill To GST"
                                                        {...register("billToGst", {
                                                            required: "This field is required",
                                                            pattern: {
                                                                value: /^[0-9A-Z]+$/,
                                                                message:
                                                                    "GST Number must be in uppercase letters and numbers only",
                                                            },
                                                        })}
                                                        onInput={(e) => {
                                                            e.target.value = e.target.value.replace(/\s/g, '').toUpperCase().slice(0, 15);
                                                        }}
                                                    />
                                                    <ErrorMessage message={errors?.billToGst?.message} />
                                                </div>

                                                <div className="mb-0">
                                                    <label className="form-label fw-semibold small text-muted">PAN <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className={`form-control`}
                                                        placeholder="Enter Bill To PAN"
                                                        {...register("billToPan", {
                                                            ...errorTypes.required("Pan card number"),
                                                            ...errorTypes.pan,
                                                        })}
                                                        onInput={(e) => {
                                                            e.target.value = e.target.value.replace(/\s/g, '').toUpperCase().slice(0, 10); // Convert to uppercase and limit to 10 characters
                                                        }}
                                                    />
                                                    <ErrorMessage message={errors?.billToPan?.message} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Ship To Section */}
                                    <div className="col-md-6">
                                        <div className="d-flex align-items-start border rounded-3 bg-white shadow-sm p-3 position-relative h-100">
                                            <div className="w-100">
                                                <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                                                    <h4 className="mb-0 rajdhani-semibold text-dark">Ship To</h4>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input rounded fs-3"
                                                            type="checkbox"
                                                            id="sameAsBillTo"
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    setValue("shipToName", getValues("billToName"));
                                                                    setValue("shipToAddress", getValues("billToAddress"));
                                                                    setValue("shipToGst", getValues("billToGst"));
                                                                    setValue("shipToPan", getValues("billToPan"));
                                                                } else {
                                                                    setValue("shipToName", "");
                                                                    setValue("shipToAddress", "");
                                                                    setValue("shipToGst", "");
                                                                    setValue("shipToPan", "");
                                                                }
                                                            }}
                                                        />
                                                        <label className="form-check-label small text-muted" htmlFor="sameAsBillTo">
                                                            Same as Bill To
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label fw-semibold small text-muted">Name <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className={`form-control`}
                                                        placeholder="Enter Ship To Name"
                                                        {...register("shipToName", { required: "Name is required" })}
                                                    />
                                                    <ErrorMessage message={errors?.shipToName?.message} />
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label fw-semibold small text-muted">Address <span className="text-danger">*</span></label>
                                                    <textarea
                                                        className={`form-control`}
                                                        placeholder="Enter Ship To Address"
                                                        rows="3"
                                                        {...register("shipToAddress", { required: "Address is required" })}
                                                    ></textarea>
                                                    <ErrorMessage message={errors?.shipToAddress?.message} />
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label fw-semibold small text-muted">GST <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className={`form-control`}
                                                        placeholder="Enter Ship To GST"
                                                        {...register("shipToGst", {
                                                            required: "This field is required",
                                                            pattern: {
                                                                value: /^[0-9A-Z]+$/,
                                                                message:
                                                                    "GST Number must be in uppercase letters and numbers only",
                                                            },
                                                        })}
                                                        onInput={(e) => {
                                                            e.target.value = e.target.value.replace(/\s/g, '').toUpperCase().slice(0, 15);
                                                        }}
                                                    />
                                                    <ErrorMessage message={errors?.shipToGst?.message} />
                                                </div>

                                                <div className="mb-0">
                                                    <label className="form-label fw-semibold small text-muted">PAN <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className={`form-control`}
                                                        placeholder="Enter Ship To PAN"
                                                        {...register("shipToPan", {
                                                            ...errorTypes.required("Pan card number"),
                                                            ...errorTypes.pan,
                                                        })}
                                                        onInput={(e) => {
                                                            e.target.value = e.target.value.replace(/\s/g, '').toUpperCase().slice(0, 10);
                                                        }}
                                                    />
                                                    <ErrorMessage message={errors?.shipToPan?.message} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <h3>Other Refenence</h3>
                                        <div className="row">
                                            <div className="col-6 mb-3">
                                                <label className="form-label fw-semibold small text-muted">Start Date </label>
                                                <Controller
                                                    name="startDate"
                                                    control={control}
                                                    rules={{
                                                        validate: (value) => {
                                                            const endDate = getValues("endDate");
                                                            if (!value && endDate) {
                                                                return "Start Date is required";
                                                            }
                                                            if (value && endDate && new Date(value) > new Date(endDate)) {
                                                                return "Start Date cannot be greater than End Date";
                                                            }
                                                            return true;
                                                        }
                                                    }}
                                                    render={({ field }) => (
                                                        <DatePicker size="sm"
                                                            {...field}
                                                            format="dd/MM/yyyy"
                                                            oneTap
                                                            placeholder="dd/mm/yyyy"
                                                            style={{ width: "100%" }}
                                                            value={field.value ? new Date(field.value) : null}
                                                            onChange={(date) => {
                                                                field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                                                                trigger("endDate");
                                                            }}
                                                            cleanable={true}
                                                            container={() => document.querySelector('.modal-content') || document.body}
                                                            placement="auto"
                                                        />
                                                    )}
                                                />
                                                <ErrorMessage message={errors?.startDate?.message} />
                                            </div>
                                            <div className="col-6 mb-3">
                                                <label className="form-label fw-semibold small text-muted">End Date</label>
                                                <Controller
                                                    name="endDate"
                                                    control={control}
                                                    rules={{
                                                        validate: (value) => {
                                                            const startDate = getValues("startDate");
                                                            if (!value && startDate) {
                                                                return "End Date is required";
                                                            }
                                                            if (value && startDate && new Date(value) < new Date(startDate)) {
                                                                return "End Date cannot be less than Start Date";
                                                            }
                                                            return true;
                                                        }
                                                    }}
                                                    render={({ field }) => (
                                                        <DatePicker size="sm"
                                                            {...field}
                                                            format="dd/MM/yyyy"
                                                            oneTap
                                                            placeholder="dd/mm/yyyy"
                                                            style={{ width: "100%" }}
                                                            value={field.value ? new Date(field.value) : null}
                                                            onChange={(date) => {
                                                                field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                                                                trigger("startDate");
                                                            }}
                                                            cleanable={true}
                                                            container={() => document.querySelector('.modal-content') || document.body}
                                                            placement="auto"
                                                        />
                                                    )}
                                                />
                                                <ErrorMessage message={errors?.endDate?.message} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>

                <div className="modal-footer p-4 border-0">
                    <button type="button" className="btn btn-secondary" onClick={onClose}>
                        Close
                    </button>

                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSubmit(onSubmit)}
                        disabled={isLoading}
                    >
                        {isLoading ? <Spinner /> : "Save"}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default UpdateBillingDetailsModal;
